import { apiClient } from './client'
import type { ApiResponse } from './client'

export type LibraryResourceType = 'video' | 'text' | 'image' | 'file'

export interface LibraryResource {
  id: number
  title: string
  description: string | null
  mediaType: LibraryResourceType
  content: string | null
  originalFilename: string | null
  contentType: string | null
  fileSize: number
  durationSeconds: number | null
  resourceUrl: string | null
  createdAt: string
}

export const adminLibraryApi = {
  list: async (): Promise<LibraryResource[]> => {
    const response = await apiClient.get<ApiResponse<LibraryResource[]>>('/lc/admin/library')
    return response.data.data ?? []
  },
}
